<template>
  <ec-flex full vertical :vGap="0" class="ec-page" alignItems="stretch">
    <slot></slot>
  </ec-flex>
</template>
<script lang="ts" setup></script>
<style scoped>
/* for phone */
@media screen and (max-width: 768px) {
  .ec-page {
    width: 100%;
    height: 100%;
    padding-left: 4px;
    padding-right: 4px;
    padding-top: 16px;
    padding-bottom: 64px;
    box-sizing: border-box;
  }
}

@media screen and (min-width: 768px) {
  .ec-page {
    flex-grow: 1;
    padding: 8px 56px 16px 24px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    background-color: #fbfbfb;
  }
}
</style>
